import {PageHeader, Dropdown, DropdownItem, EitjeButton, AdvancedTableOptions} from '~/components'
import {TABLE_INFO} from '~/components/advanced_table/instances/organisations/constants'

export const OrganisationsPageHeader = () => {
	return <PageHeader label="common.organisations" right={[<AdvancedTableOptions key={0} {...TABLE_INFO} />, <Tools key={1} />]} />
}

const Tools = () => {
	return (
		<Dropdown trigger={<EitjeButton t="common.tools" height="small" iconRight="chevron-small-down" />}>
			<DropdownItem t="common.search" iconLeft="magnifying-glass" to="/search/firm" />
			<DropdownItem t="organisations.tools.split" iconLeft="link" modalLink="/firms/organisations/split" />
		</Dropdown>
	)
}
